import useBreakpointRedirection, { useBreakpointRedirectionType } from './useBreakpointRedirection'


const BreakpointRedirection = (config: useBreakpointRedirectionType) => {
    useBreakpointRedirection(config)
    return null
}

export default BreakpointRedirection
